/** @format */

import { isArray, isEmpty } from "lodash";
import qs from "query-string";
import { React, useEffect, useMemo, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { QueryClient, QueryClientProvider } from "react-query";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CSSTransition } from "react-transition-group";
import "rsuite/dist/rsuite.min.css";
import { v4 as uuid } from "uuid";
import "./App.css";
import BankApp from "./components/BankApp";
import BankTransfer from "./components/BankTransfer";
import MobileMoney from "./components/MobileMoney";
import PaymentMethods, {
    PaymentMethod,
    PaymentOnlyMethod,
} from "./components/PaymentMethods";
import PaymentSummary from "./components/PaymentSummary";
import QrCode from "./components/QrCode";
import StripeCardPayment from "./components/StripeCardPayment";
import Success from "./components/Success";
import USSD from "./components/USSD";
import XcelPay from "./components/XcelPay";

import HandleAmount from "./components/HandleAmount";
import axios, { setAuthorisationToken } from "./lib/axios";
import { getCountryByCode } from "./lib/countries";
import { useGeneralState } from "./state/useGeneralState";
import { Provider } from 'react-redux';
import store from '../src/state/store.js';
import MasterCardSuccess from './components/MasterCardSuccess';

const queryClient = new QueryClient();

function App() {
    const [step, setStep] = useState(3);
    const [country, setCountry] = useState();
    const [currency, setCurrency] = useState();
    const [merchantDetails, setMerchantDetails] = useState();
    const [isReady, setIsReady] = useState(false);
    const [merchant, setMerchant] = useState();
    const [stripeId, setStripeId] = useState();
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [user, setUser] = useState();
    const [reference, setRefence] = useState();
    const [isSuccess, setIsSuccess] = useState(false);
    const { method, setMethod, setEnv, env } = useGeneralState();
    const [isGiftAid, setIsGiftAid] = useState(false);
    const [isUKMerchant, setIsUKMerchant] = useState(null);
    const [productList, setProductList] = useState([]);
    const query = qs.parse(window.location.search);
    const isLive = query.publicKey?.includes("XCLPUBK_LIVE");
    const onlyAllowedPayment = query?.onlyAllowedPayment ?? "";
    const redirectWhenCancelledUrl = query?.redirectWhenCancelledUrl ?? "";
    const redirectWhenSuccessfulUrl = query?.redirectWhenSuccessfulUrl ?? "";
    const [selectedMNO, setSelectedMNO] = useState("");
    const [fees, setFees] = useState(0);

    const propsProductIds = JSON.parse(query?.productIds ?? "[]");
    let shouldModifyAmount = useMemo(() => {
        if (isEmpty(propsProductIds)) {
            return true;
        }

        if (!isArray(propsProductIds)) {
            return true;
        }

        if (propsProductIds.length <= 0) {
            return true;
        }

        const isValidProductIds = propsProductIds.every(
            (item) => item.name && item.product_id && item.amount
        );

        if (!isValidProductIds) {
            return true;
        }

        const shouldModifyAmountValue =
            (query?.shouldModifyAmount ?? "true") == "true";

        return shouldModifyAmountValue;
    }, [query, propsProductIds]);

    const [isProduct, setIsProduct] = useState(shouldModifyAmount);
    const shouldOnlyAllowPayment = !isEmpty(onlyAllowedPayment);
    const [products, setProducts] = useState(propsProductIds);
    const [selectedProducts, setSelectedProducts] = useState({});
    const [once, setOnce] = useState(false);
    const [amount, setAmount] = useState(query?.amount ?? 0);
    const [totalAmount, setTotalAmount] = useState(query?.amount ?? 0);

    const customer = JSON.parse(query?.customer ?? "{}");
    const description = query?.description ?? "";
    const metadata = query?.metadata ?? '';

    // if (!isLive) {
    //     if (!query?.publicKey) {
    //         query.publicKey =
    //             "XCLPUBK_TEST-62a3d9d8933e7aafd507691c385f1852f91aaff1";
    //     }

    //     if (!query?.merchantId) {
    //         // query.merchantId = 'BSWkPrkRJ'; // your merchant id
    //         query.merchantId = ""; // your merchant id
    //     }

    //     if (!query?.customer) {
    //         query.customer = JSON.stringify({
    //             name: "Victor Umesiobi",
    //             email: "victor.umesiobi@etranzactglobal.com",
    //         });
    //         query.reference = "XPG-" + Date().toString() + uuid();
    //     }

    //     if (!query?.amount) {
    //         query.amount = 300; // amount to be paid
    //     }

    //     if (!query?.currency) {
    //         query.alpha2CountryCode = "GB"; //country code in uppercase
    //         query.currency = "GBP";
    //     }
    // }

    const customerName = customer?.name ?? "";
    const customerEmail = customer?.email ?? "";
    const tempAmount = query?.amount ?? 0;
    const productId = query?.productId ?? '';

    const keys = isLive
        ? "pk_live_51EMKTHLbNZfBtQStVr0BvJiwt7mh7fEZQ6SchfGqlkUK7DZ1O3AygcINYvrbNNAeYA5qiCucDU43wDeF6Ydmy4YL00otnqOPT0"
        : "pk_test_sJIuunk2QliIlIH35cSlX9ku00S65bZBWh";

    const {
        setUrl,
        setTransactionBaseUrl,
        setMonoUrl,
        setDLCodeUrl,
        setXcelPaymentUrl,
    } = useGeneralState();

    const onMethodSelected = (method) => {
        setMethod(method);
        setIsSuccess(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getMerchantDetails = async () => {
        setIsReady(false);

        //get the merchant id and token from query
        let token, url, transactionBaseUrl, monoUrl, dlCodeUrl, xcelPaymentUrl;
        if (isLive) {
            url = "https://api.xcelapp.com/business-api/";
            transactionBaseUrl =
                "https://api.xcelapp.com/transactions-service/";
            // monoUrl = "https://api.xcelapp.com/momo/";
            monoUrl = "https://api.xcelapp.com/xas/v1/";
            dlCodeUrl = "https://api.xcelapp.com/esa/";
            xcelPaymentUrl = "https://api.xcelapp.com/xas/v1/";

            setUrl(url);
            setTransactionBaseUrl(transactionBaseUrl);
            setMonoUrl(monoUrl);
            setDLCodeUrl(dlCodeUrl);
            setXcelPaymentUrl(xcelPaymentUrl);
            setEnv("production");
        } else {
            url = "https://api.xcelapp.com/business-api/";
            monoUrl = "https://api.xcelapp.com/xas/v1/";
            transactionBaseUrl =
                "https://api.xcelapp.com/transactions-service/";
            dlCodeUrl = "https://api.xcelapp.com/esa/";
            xcelPaymentUrl = "https://api.xcelapp.com/xas/v1/";

            setTransactionBaseUrl(transactionBaseUrl);
            setUrl(url);
            setMonoUrl(monoUrl);
            setXcelPaymentUrl(xcelPaymentUrl);

            setDLCodeUrl(dlCodeUrl);
            // setEnv("test");
            setEnv("production");
        }

        setRefence(query?.reference ?? "XPG-" + Date().toString() + uuid());

        try {
            const merchantDetail = await axios.get(
                `${url}merchant/details/${query.merchantId}`,
                {
                    headers: {
                        Authorization: query.publicKey,
                    },
                }
            );

            const details = merchantDetail?.data?.data?.data;
            setStripeId(details?.stripe_id ?? undefined);
            setMerchantDetails(details);
            setIsUKMerchant(details?.currency?.iso_code_2 === 'GB');
            // if(details.currency?.iso_code_2 === 'GB') {
            //     details?.payment_options.push('Pay with Apple Pay');
            // }
            setPaymentMethods(details?.payment_options ?? []);
            if (details?.ent_type === "RELIGIOUS") {
                setMethod(PaymentMethod.PayWithCard);
            } else {
                setMethod(PaymentMethod.PayWithXCEL);
            }
        } catch (e) {}

        try {
            const validation_response = await axios.get(
                `${url}merchant/pay/validate/${query.merchantId}`,
                {
                    headers: {
                        Authorization: query.publicKey,
                    },
                }
            );

            token = validation_response?.data?.data?.token
            setAuthorisationToken(token, url);
            localStorage.setItem('token', token);
        } catch (e) {

        }

        const payer_country = getCountryByCode(query?.alpha2CountryCode);
        setCountry(payer_country);
        const payer_currency = payer_country?.currencies.filter(
            (curr) => curr.code === query?.currency
        )[0];

        setCurrency(payer_currency);

        try {
            const headers = {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        
            const merchant_response = await axios.get(
                `${url}merchant/pos/${query.merchantId}`,
                {
                    headers: headers,
                }
            );
            const merchant_data = merchant_response.data.data;
            setMerchant(merchant_data);
            setStep(3);
        } catch (e) {
            toast.error("Error fetching merchant details");
            console.error("Error fetching merchant data: ", e);
            return;
        }        

        setIsReady(true);
    };

    const onPaymentSuccess = () => {
        setIsSuccess(true);
    };

    const onFeesFetchSuccess = (fees) => {
        setFees(fees);
    };

    const onTotalAmountChange = (totalAmount) => {
        setTotalAmount(totalAmount);
        setAmount(totalAmount);
    };

    const onUserVerified = (userData) => {
        setUser(userData);
    };

    const onMnoSelected = (mno) => {
        setSelectedMNO(mno);
    };

    const isNotSuccess = !isSuccess;

    useEffect(() => {
        getMerchantDetails();
    }, []);

    // if (window.location.pathname.toLowerCase().includes('mastercard')) {
    //     return <MasterCardSuccess />;
    // }

    const queryParams = new URLSearchParams(window.location.search);
    const successPage = queryParams.get('successPage');

    if (successPage?.toLowerCase() === 'mastercard') {
        return <MasterCardSuccess />;
    }

    if (isUKMerchant === false) {
        return (
            <div className="w-full min-h-screen flex justify-center items-center bg-[#F1F1F1]">
                <div className="bg-white rounded-lg shadow-md p-10 max-w-md text-center">
                    <div className="text-5xl mb-4">🚫</div>
                    <h1 className="text-2xl font-bold text-gray-800 mb-2">
                        Access Restricted
                    </h1>
                    <p className="text-gray-500">
                        This service is currently unavailable in your region.
                    </p>
                    {merchantDetails?.merchant_id && (
                        <a 
                            href={`https://paygate.xcelapp.com/pay/${merchantDetails.merchant_id}`}
                            className="mt-6 inline-block text-blue-600 underline text-sm"
                            target="_blank" rel="noreferrer"
                        >
                            Click here to make a payment
                        </a>
                    )}
                </div>
            </div>
        );
    }

    return (
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <div className=" w-full justify-center items-center flex">
                    <div className="md:p-5 p-0 md:w-auto w-full bg-[#F1F1F1]  min-h-[400px]">
                        {isProduct ? (
                            <div className="modal flex md:flex-row flex-col gap-3 w-full">
                                <div
                                    className={
                                        "w-full rounded-md h-full md:px-4 px-0 "
                                    }>
                                    <div
                                        className={`bg-white w-full h-full relative rounded-sm`}>
                                        <HandleAmount
                                            publicKey={query.publicKey}
                                            isGuest={JSON.parse(query?.customer)?.guest}
                                            merchant={merchant}
                                            tempAmount={tempAmount}
                                            productId={productId}
                                            setPropsProducts={(e) => {
                                                setProducts(e);
                                            }}
                                            setSelectedProduct={(e) => {
                                                setSelectedProducts(e);
                                            }}
                                            shouldModifyAmount={
                                                shouldModifyAmount
                                            }
                                            isGiftAid={isGiftAid}
                                            setIsGiftAid={(e) => {
                                                setIsGiftAid(e);
                                            }}
                                            setIsProduct={() => {
                                                setIsProduct(false);
                                            }}
                                            setPropProductList={(e) => {
                                                setProductList(e);
                                            }}
                                            isProduct={!isProduct}
                                            once={once}
                                            setOnce={setOnce}
                                            propsProduct={products}
                                            merchantDetails={merchantDetails}
                                            amount={amount}
                                            setPropsAmount={(e) => {
                                                setAmount(e);
                                            }}
                                            propsProductIds={propsProductIds}
                                            currency={currency}
                                            customerName={
                                                customerName
                                            }
                                            customerEmail={
                                                customerEmail
                                            }
                                            onTotalAmountChange={
                                                onTotalAmountChange
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="md:flex hidden flex-row w-full h-full md:w-[50%] justify-between items-center md:px-4 px-0 py-4 md:py-0">
                                    <PaymentSummary
                                        total={amount}
                                        sumTotal={amount}
                                        currency={currency}
                                        shouldOnlyAllowPayment={
                                            shouldOnlyAllowPayment
                                        }
                                        fees={fees}
                                        vat={0.0}
                                        merchant={
                                            merchantDetails?.reg_name ?? ""
                                        }
                                        merchantDetails={merchantDetails}
                                    />
                                </div>
                            </div>
                        ) : (
                            <HandleAmount
                                publicKey={query.publicKey}
                                isGuest={JSON.parse(query?.customer)?.guest}
                                merchant={merchant}
                                tempAmount={tempAmount}
                                setPropsProducts={(e) => {
                                    setProducts(e);
                                }}
                                setSelectedProduct={(e) => {
                                    setSelectedProducts(e);
                                }}
                                shouldModifyAmount={shouldModifyAmount}
                                isGiftAid={isGiftAid}
                                setIsProduct={() => {
                                    setIsProduct(false);
                                }}
                                setPropProductList={(e) => {
                                    setProductList(e);
                                }}
                                setIsGiftAid={(e) => {
                                    setIsGiftAid(e);
                                }}
                                isProduct={!isProduct}
                                once={once}
                                setOnce={setOnce}
                                propsProduct={products}
                                merchantDetails={merchantDetails}
                                amount={amount}
                                setPropsAmount={(e) => {
                                    setAmount(e);
                                }}
                                propsProductIds={propsProductIds}
                                currency={currency}
                                customerName={
                                    customerName
                                }
                                customerEmail={
                                    customerEmail
                                }
                                onTotalAmountChange={
                                    onTotalAmountChange
                                }
                            />
                        )}

                        {!isProduct && (
                            <div className="modal flex-col gap-3 justify-between w-full h-full">
                                <div className="modal flex md:flex-row flex-col-reverse justify-between w-full h-full">
                                    <div
                                        className={`${
                                            isNotSuccess
                                                ? "md:w-[69%]"
                                                : "w-full"
                                        } h-full`}>
                                        {isNotSuccess && (
                                            <div className="bg-[#A4A4A4] w-full h-[50px] px-4 text-white justify-start flex items-center font-bold">
                                                {shouldModifyAmount && (
                                                    <div
                                                        className="mr-2 cursor-pointer hidden md:flex"
                                                        onClick={() => {
                                                            if(!productId) {
                                                                setIsProduct(true);
                                                            }
                                                        }}>
                                                        <BsArrowLeft />
                                                    </div>
                                                )}
                                                <div className="">
                                                    {merchantDetails?.ent_type ===
                                                    "RELIGIOUS"
                                                        ? "Give"
                                                        : "Pay"}{" "}
                                                    With
                                                </div>
                                            </div>
                                        )}

                                        <div className="w-full bg-white relative h-full">
                                            <div
                                                className={`modal-body m-auto pt-4 flex flex-col flex-1 md:flex-row  ${
                                                    !isNotSuccess
                                                        ? "justify-center items-center"
                                                        : ""
                                                }`}>
                                                {isNotSuccess && (
                                                    <div className="payment-methods md:flex-col flex-row gap-2 justify-start items-start ">
                                                        <p
                                                            className={`pl-4 text-[#777777] mb-5 ${
                                                                !isEmpty(
                                                                    onlyAllowedPayment
                                                                )
                                                                    ? "hidden md:flex"
                                                                    : ""
                                                            }`}>
                                                            {merchantDetails?.ent_type ===
                                                            "RELIGIOUS"
                                                                ? "Giving"
                                                                : "Payment"}{" "}
                                                            Options
                                                        </p>

                                                        <PaymentMethods
                                                            onMethodSelected={
                                                                onMethodSelected
                                                            }
                                                            selectedPaymentMethod={
                                                                paymentMethods
                                                            }
                                                            onlyAllowedPayment={
                                                                onlyAllowedPayment
                                                            }
                                                            merchantDetails={
                                                                merchantDetails
                                                            }
                                                            selectedMno={
                                                                selectedMNO
                                                            }
                                                            description={JSON.stringify(
                                                                selectedProducts
                                                            )}
                                                            selectedMethod={
                                                                method
                                                            }
                                                            setSelectedProduct={(
                                                                e
                                                            ) => {
                                                                setSelectedProducts(
                                                                    e
                                                                );
                                                            }}
                                                            onFeesFetchSuccess={
                                                                onFeesFetchSuccess
                                                            }
                                                            onTotalAmountChange={
                                                                onTotalAmountChange
                                                            }
                                                        />
                                                    </div>
                                                )}

                                                <div className="relative h-full">
                                                    {isSuccess ? (
                                                        <div className="payment-page row-start-1 col-span-4 w-full">
                                                            <CSSTransition
                                                                timeout={500}
                                                                classNames="item">
                                                                <Success
                                                                    setStep={
                                                                        setStep
                                                                    }
                                                                    merchant={
                                                                        merchantDetails
                                                                    }
                                                                    country={
                                                                        country
                                                                    }
                                                                    customerName={
                                                                        customerName
                                                                    }
                                                                    customerEmail={
                                                                        customerEmail
                                                                    }
                                                                    user={user}
                                                                    reference={
                                                                        reference
                                                                    }
                                                                    amount={
                                                                        amount
                                                                    }
                                                                    sumTotal={
                                                                        amount
                                                                    }
                                                                    currency={
                                                                        currency
                                                                    }
                                                                    redirectWhenCancelledUrl={
                                                                        redirectWhenCancelledUrl
                                                                    }
                                                                    redirectWhenSuccessfulUrl={
                                                                        redirectWhenSuccessfulUrl
                                                                    }
                                                                />
                                                            </CSSTransition>
                                                        </div>
                                                    ) : (
                                                        <div className="w-full h-full relative">
                                                            {isReady ? (
                                                                <div className="">
                                                                    {(shouldOnlyAllowPayment
                                                                        ? PaymentOnlyMethod.xcel ==
                                                                        onlyAllowedPayment
                                                                        : method ===
                                                                        PaymentMethod.PayWithXCEL) && (
                                                                        <XcelPay
                                                                            merchant={
                                                                                merchant
                                                                            }
                                                                            merchantName={
                                                                                merchantDetails?.reg_name ??
                                                                                ""
                                                                            }
                                                                            isGiftAid={
                                                                                isGiftAid
                                                                            }
                                                                            metadata={
                                                                                metadata
                                                                            }
                                                                            propsAmount={
                                                                                amount
                                                                            }
                                                                            tempAmount={
                                                                                tempAmount
                                                                            }
                                                                            setPropsAmount={(
                                                                                e
                                                                            ) => {
                                                                                setAmount(
                                                                                    e
                                                                                );
                                                                            }}
                                                                            customerEmail={
                                                                                customerEmail
                                                                            }
                                                                            propsDescription={JSON.stringify(
                                                                                selectedProducts
                                                                            )}
                                                                            propsProductIds={
                                                                                propsProductIds
                                                                            }
                                                                            shouldModifyAmount={
                                                                                shouldModifyAmount
                                                                            }
                                                                            productList={
                                                                                productList
                                                                            }
                                                                            onlyAllowedPayment={
                                                                                onlyAllowedPayment
                                                                            }
                                                                            description={
                                                                                description
                                                                            }
                                                                            country={
                                                                                country
                                                                            }
                                                                            reference_id={
                                                                                reference
                                                                            }
                                                                            setMethod={
                                                                                setMethod
                                                                            }
                                                                            productAndAmount={
                                                                                selectedProducts
                                                                            }
                                                                            onPaymentSuccess={
                                                                                onPaymentSuccess
                                                                            }
                                                                            onUserVerified={
                                                                                onUserVerified
                                                                            }
                                                                            currency={
                                                                                currency
                                                                            }
                                                                            token={
                                                                                query.publicKey
                                                                            }
                                                                            merchantDetails={
                                                                                merchantDetails
                                                                            }
                                                                            sumTotal={
                                                                                amount
                                                                            }
                                                                        />
                                                                    )}

                                                                    {(shouldOnlyAllowPayment
                                                                        ? PaymentOnlyMethod.card ==
                                                                        onlyAllowedPayment
                                                                        : method ===
                                                                        PaymentMethod.PayWithCard) && (
                                                                        <div
                                                                            className={`${
                                                                                (
                                                                                    shouldOnlyAllowPayment
                                                                                        ? false
                                                                                        : method !==
                                                                                        PaymentMethod.PayWithCard
                                                                                )
                                                                                    ? "hidden"
                                                                                    : ""
                                                                            } w-full h-full`}>
                                                                            <StripeCardPayment
                                                                                {...{
                                                                                    amount,
                                                                                    query,
                                                                                    onPaymentSuccess,
                                                                                    country,
                                                                                    currency,
                                                                                    customerEmail,
                                                                                    productList,
                                                                                    customerName,
                                                                                    productsAndAmount:
                                                                                        selectedProducts,
                                                                                    description:
                                                                                        JSON.stringify(
                                                                                            products
                                                                                        ),
                                                                                    onlyAllowedPayment,
                                                                                    keys,
                                                                                    reference,
                                                                                    setUser,
                                                                                    stripeId,
                                                                                    user,
                                                                                    isGiftAid,
                                                                                    merchantId:
                                                                                        query.merchantId,
                                                                                    merchantName:
                                                                                        merchantDetails?.reg_name,
                                                                                    merchantDetails:
                                                                                        merchantDetails,
                                                                                    redirectWhenCancelledUrl: redirectWhenCancelledUrl,
                                                                                    redirectWhenSuccessfulUrl: redirectWhenSuccessfulUrl
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}

                                                                    {(shouldOnlyAllowPayment
                                                                        ? PaymentOnlyMethod.bank_app ==
                                                                        onlyAllowedPayment
                                                                        : method ===
                                                                        PaymentMethod.PayWithBankApp) && (
                                                                        <BankApp
                                                                            merchant={
                                                                                merchant
                                                                            }
                                                                            amount={
                                                                                amount
                                                                            }
                                                                            country={
                                                                                country
                                                                            }
                                                                            onlyAllowedPayment={
                                                                                onlyAllowedPayment
                                                                            }
                                                                            onPaymentSuccess={
                                                                                onPaymentSuccess
                                                                            }
                                                                            setMethod={
                                                                                setMethod
                                                                            }
                                                                            currency={
                                                                                currency
                                                                            }
                                                                            description={JSON.stringify(
                                                                                selectedProducts
                                                                            )}
                                                                            isGiftAid={
                                                                                isGiftAid
                                                                            }
                                                                            customerEmail={
                                                                                customerEmail
                                                                            }
                                                                            customerName={
                                                                                customerName
                                                                            }
                                                                            reference={
                                                                                reference
                                                                            }
                                                                            merchantId={
                                                                                merchantDetails?.merchant_id
                                                                            }
                                                                        />
                                                                    )}

                                                                    {(shouldOnlyAllowPayment
                                                                        ? PaymentOnlyMethod.bank_account ==
                                                                        onlyAllowedPayment
                                                                        : method ===
                                                                        PaymentMethod.PayWithBankAccount) && (
                                                                        <BankTransfer
                                                                            merchant={
                                                                                merchant
                                                                            }
                                                                            amount={
                                                                                amount
                                                                            }
                                                                            country={
                                                                                country
                                                                            }
                                                                            onlyAllowedPayment={
                                                                                onlyAllowedPayment
                                                                            }
                                                                            onPaymentSuccess={
                                                                                onPaymentSuccess
                                                                            }
                                                                            setMethod={
                                                                                setMethod
                                                                            }
                                                                            currency={
                                                                                currency
                                                                            }
                                                                        />
                                                                    )}

                                                                    {(shouldOnlyAllowPayment
                                                                        ? PaymentOnlyMethod.momo ==
                                                                        onlyAllowedPayment
                                                                        : method ===
                                                                        PaymentMethod.PayWithMobileMoney) && (
                                                                        <MobileMoney
                                                                            country={
                                                                                country
                                                                            }
                                                                            currency={
                                                                                currency
                                                                            }
                                                                            reference={
                                                                                reference
                                                                            }
                                                                            amount={
                                                                                amount
                                                                            }
                                                                            metadata={
                                                                                metadata
                                                                            }
                                                                            fees={
                                                                                fees
                                                                            }
                                                                            onlyAllowedPayment={
                                                                                onlyAllowedPayment
                                                                            }
                                                                            merchantId={
                                                                                query.merchantId
                                                                            }
                                                                            onPaymentSuccess={
                                                                                onPaymentSuccess
                                                                            }
                                                                            customerEmail={
                                                                                customerEmail
                                                                            }
                                                                            customerName={
                                                                                customerName
                                                                            }
                                                                            description={JSON.stringify(
                                                                                selectedProducts
                                                                            )}
                                                                            merchantDetails={
                                                                                merchantDetails
                                                                            }
                                                                            onMnoSelected={
                                                                                onMnoSelected
                                                                            }
                                                                            selectedMethod={
                                                                                method
                                                                            }
                                                                            onFeesFetchSuccess={
                                                                                onFeesFetchSuccess
                                                                            }
                                                                            onTotalAmountChange={
                                                                                onTotalAmountChange
                                                                            }
                                                                        />
                                                                    )}

                                                                    {/* <USSD /> */}
                                                                    {(shouldOnlyAllowPayment
                                                                        ? PaymentOnlyMethod.ussd ==
                                                                        onlyAllowedPayment
                                                                        : method ===
                                                                        PaymentMethod.PayWithUSSD) && (
                                                                        <USSD
                                                                            merchantDetails={
                                                                                merchantDetails
                                                                            }
                                                                            onlyAllowedPayment={
                                                                                onlyAllowedPayment
                                                                            }
                                                                        />
                                                                    )}
                                                                    {(shouldOnlyAllowPayment
                                                                        ? PaymentOnlyMethod.qr_code ==
                                                                        onlyAllowedPayment
                                                                        : method ===
                                                                        PaymentMethod.PayWithQRCode) && (
                                                                        <QrCode
                                                                            onlyAllowedPayment={
                                                                                onlyAllowedPayment
                                                                            }
                                                                        />
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="payment-page row-start-1 col-span-4" />
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {isNotSuccess && (
                                        <div className="md:w-[30%] w-full flex flex-col justify-between">
                                            <PaymentSummary
                                                total={amount}
                                                sumTotal={amount}
                                                currency={currency}
                                                setIsProduct={() => {
                                                    setIsProduct(true);
                                                }}
                                                shouldModifyAmount={
                                                    shouldModifyAmount
                                                }
                                                shouldOnlyAllowPayment={
                                                    shouldOnlyAllowPayment
                                                }
                                                fees={fees}
                                                vat={0.0}
                                                merchant={
                                                    merchantDetails?.reg_name ??
                                                    ""
                                                }
                                                merchantDetails={
                                                    merchantDetails
                                                }
                                            />
                                        </div>
                                    )}
                                </div>

                                {isNotSuccess && (
                                    <div className="w-full flex flex-col justify-between">
                                        <div className="w-full flex items-end justify-end mt-3">
                                            {/* <img
                                                src='./images/etranzact.png'
                                                alt=''
                                                className=' h-10'
                                            /> */}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <ToastContainer position="top-right" />
            </Provider>
        </QueryClientProvider>
    );
}

export default App;
